import { createHashHistory } from 'history';
import _ from 'underscore';
import React, { Component } from 'react';
import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import entityComposition from '../../common/classes/entityComposition';
import { getPermissions } from '../../../utils/paths';
const hashHistory = createHashHistory();
class Design extends Component {
  componentDidMount() {
    if (!_.contains(getPermissions().general, 'user_edit')) {
      const _this$props = this.props,
        location = _this$props.location,
        notificationActions = _this$props.notificationActions;
      notificationActions.error({
        headerMessage: 'You are not authorized to access:',
        message: location.pathname
      });
      hashHistory.replace('/accessDenied');
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("h4", null, "The design section is coming soon!"));
  }
}
Design.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired
};
export default entityComposition(Design, [], {}, ['notification']);